import { useIsCarrier } from '@/hooks/useRoles';
import ApiAccessTab from './ApiAccessTab';
import CarrierIntegrationPage from './CarrierIntegrationPage';

// Содержимое слота api-access по роли: перевозчику — «Интеграция» (подключение его сервера),
// прочим не-агентам — партнёрский API «API-доступ». Обе роли уже прошли RequireNonAgent.
export default function ApiAccessRoute() {
  return useIsCarrier() ? <CarrierIntegrationPage /> : <ApiAccessTab />;
}
